export default "plusd5dca73bc12bf158.svg"